import Vue from 'vue';
import VueI18n from 'vue-i18n';

import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import esLocale from 'element-ui/lib/locale/lang/es'
import csLocale from 'element-ui/lib/locale/lang/cs-CZ'
import ptLocale from 'element-ui/lib/locale/lang/pt'
import plLocale from 'element-ui/lib/locale/lang/pl'
import ElementLocale from 'element-ui/lib/locale'

import zhCN from "./lang/zhCh.js";
import en from "./lang/en.js";
import es from "./lang/es.js";
import cs from "./lang/cs.js";
import pt from "./lang/pt.js";
import pl from "./lang/pl.js";

const browserLang = navigator.language || 'en-US';
const supportedLangs = ['zh', 'en', 'es','cs','pt', 'pl']; // 支持的语言列表
const i18nLang = supportedLangs.includes(browserLang.split('-')[0]) 
  ? browserLang.split('-')[0] 
  : 'en';

Vue.use(VueI18n)

// 准备翻译的语言环境信息
const messages = {
    // zh:中文 en:英文 es:西班牙语 cs:捷克语 pt:葡萄牙语
    'zh': { ...zhCN, ...zhLocale },
    'en': {
        ...en,
        ...enLocale // 或者用 Object.assign({ message: 'XX' }, enLocale)
    },
    'es': {
        ...es,
        ...esLocale
    },
    'cs': {
        ...cs,
        ...csLocale
    },
    'pt': {
        ...pt,
        ...ptLocale
    },
      'pl': {
        ...pl,
        ...plLocale
    },
}

// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
    locale: i18nLang, // 设置地区
    messages, // 设置地区信息
})

sessionStorage.setItem('lang',i18nLang)


ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n;





// WEBPACK FOOTER //
// ./src/i18n/i18n.js